module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("The British author, Joey Marcelle was born in 1988 and raised in Manchester, England. "), _c('em', [_vm._v("Nothing Is as It Seems")]), _vm._v(" is the first of what hopes to be a series of books. With a strong passion for creativity, Joey Marcelle works within the entertainment industry. The book was created from her passion and love of reading thrillers. "), _c('em', [_vm._v("Nothing Is as It Seems")]), _vm._v(" is an action-fuelled plot that is thought-provoking, gripping, full of suspense and encompasses a variety of themes.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0